import { useIntl } from 'react-intl';

import { Box, Text } from '@atlaskit/primitives';

import { messages } from 'src/components/pipelines/components/test-management';

export const TestManagementTableEmptyView = () => {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Text>{formatMessage(messages.emptyTableMessage)}</Text>
    </Box>
  );
};
